import React, { useState } from 'react'
import Navbar from '../components/Navbar'
import Sidebar from '../components/Sidebar'
import HeroSection from '../components/HeroSection'
import InfoSection from '../components/InfoSection'
import { homeObjTwo } from '../components/InfoSection/Data'
import ContactForm from '../components/ContactForm/ContactForm'
import OurWorkSection from '../components/OurWork'
import OurClients from '../components/OurClients'
import Footer from '../components/Footer'

const Home = () => {
  const [isOpen, setIsOpen] = useState(false)

  const toggle = () => {
    setIsOpen(!isOpen)
  }

  return (
    <>
      <Sidebar isOpen={isOpen} toggle={toggle} />
      <Navbar toggle={toggle} />
      <HeroSection />
      <OurWorkSection />
      <OurClients />
      <InfoSection {...homeObjTwo} />
      <ContactForm />
      <Footer />
    </>
  )
}

export default Home
